import React, { Component } from "react";

const stateKey = "state";
const pendingKey = "pending";

class App extends Component {
    constructor() {
        super();

        this.spreadsheetId = "1NhmbqYlXlvL64oRDDOQXF801YA7-fY_FcAxXnz0NKAs";

        this.state = {
            signedIn: undefined,
            rubenTotal: undefined,
            tinneTotal: undefined,
            transactions: [],
            loaded: false,
            showStatus: false,
        };

        window.addEventListener("online", this.submitPending);
        document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
                this.load();
            }
        });
    }

    componentDidMount() {
        this.store = this.props.store;
        this.gapi = this.props.gapi;
        this.gapi.listenSignin(this.signedInChanged);
        this.loadState();
        this.loadPending();
    }

    async loadState() {
        const state = await this.store.get(stateKey);
        if (state) {
            this.setState(state);
        }
    }

    async loadPending() {
        const pending = await this.store.get(pendingKey);
        if (pending && pending.length > 0) {
            this.submitPending();
        }
    }

    submitPending = async () => {
        const pending = await this.store.get(pendingKey);
        if (!pending || pending.length === 0) {
            // Nothing to do!
            this.setState({ showStatus: false });
            return;
        }

        if (!window.navigator.onLine) {
            this.setState({ showStatus: true, pending: pending.length });
            return;
        }

        this.setState({
            showStatus: true,
            submitting: true,
            pending: pending.length,
        });
        return this.gapi
            .append({
                spreadsheetId: this.spreadsheetId,
                range: "A5",
                valueInputOption: "USER_ENTERED",
                insertDataOption: "INSERT_ROWS",
                values: pending,
            })
            .then(
                async () => {
                    await this.store.set(pendingKey, []);
                    await this.load();
                    this.setState({ showStatus: false });
                },
                () => {
                    this.setState({
                        showStatus: true,
                        submitting: false,
                        pending: pending.length,
                    });
                },
            );
    };

    signedInChanged = signedIn => {
        this.setState({ signedIn: signedIn });
        if (this.state.signedIn) {
            this.load();
        }
    };

    parseAmount(amount) {
        if (!amount) {
            return 0;
        }
        const matches = amount.match(/€ ([\d\\.,]+)/);
        return matches.length === 2
            ? parseFloat(matches[1].replace(",", ""), 10)
            : 0;
    }

    parseTx(tx, index) {
        while (tx.length < 4) {
            tx.push("");
        }
        return {
            key: index,
            date: tx[0],
            desc: tx[1],
            ruben: tx[2],
            tinne: tx[3],
        };
    }

    load = async () => {
        if (!this.state.signedIn) {
            return;
        }

        const ranges = await this.gapi.batchGet({
            spreadsheetId: this.spreadsheetId,
            ranges: ["H2", "H3", "A5:D"],
        });

        const rubenTotal = ranges.result.valueRanges[0].values[0][0];
        const tinneTotal = ranges.result.valueRanges[1].values[0][0];
        const transactions = (ranges.result.valueRanges[2].values || [])
            .slice(-25)
            .map(this.parseTx)
            .sort((a, b) => b.date.localeCompare(a.date));

        const stateUpdates = {
            rubenTotal: rubenTotal,
            tinneTotal: tinneTotal,
            loaded: true,
            signedIn: true,
            transactions: transactions,
        };

        this.setState(stateUpdates);
        this.store.set(stateKey, stateUpdates);
    };

    addNew() {
        const now = new Date();
        const month = now.getMonth() + 1;
        const day = now.getDate();
        this.setState({
            new: {
                date:
                    now.getFullYear() +
                    "-" +
                    (month < 10 ? "0" : "") +
                    month +
                    "-" +
                    (day < 10 ? "0" : "") +
                    day,
                desc: "",
                ruben: "",
                tinne: "",
            },
            showAdd: true,
        });
    }

    handleDate = e => {
        const n = this.state.new;
        n.date = e.target.value;
        this.setState({ new: n });
    };

    handleDesc = e => {
        const n = this.state.new;
        n.desc = e.target.value;
        this.setState({ new: n });
    };

    handleRuben = e => {
        const n = this.state.new;
        n.ruben = e.target.value;
        this.setState({ new: n });
    };

    handleTinne = e => {
        const n = this.state.new;
        n.tinne = e.target.value;
        this.setState({ new: n });
    };

    handleSubmit = async e => {
        e.preventDefault();

        let pending = await this.store.get(pendingKey);
        if (!pending) {
            pending = [];
        }

        const n = this.state.new;
        pending.push([n.date, n.desc, n.ruben, n.tinne]);

        await this.store.set(pendingKey, pending);
        this.setState({ showAdd: false });

        await this.submitPending();
        // TODO: Error handling
    };

    render() {
        return (
            <div>
                <div className="main">
                    {this.state.signedIn === undefined && <h2>Loading...</h2>}
                    {this.state.signedIn === false && (
                        <div>
                            <h2>Login required</h2>
                            <button
                                onClick={() => {
                                    this.gapi.signIn();
                                }}
                            >
                                Sign In
                            </button>
                        </div>
                    )}
                    {this.state.signedIn &&
                        this.state.loaded &&
                        this.renderBody()}
                </div>
                {this.state.signedIn &&
                    this.state.showStatus && (
                        <div className="status">
                            {this.state.submitting && (
                                <span>Adding ({this.state.pending})...</span>
                            )}
                            {!this.state.submitting && (
                                <span>
                                    Waiting to send {this.state.pending} item{this
                                        .state.pending !== 1 && "s"}{" "}
                                    (offline)...
                                </span>
                            )}
                        </div>
                    )}
                {this.state.signedIn &&
                    !this.state.showAdd && (
                        <div className="addNew">
                            <button
                                className="addBtn"
                                onClick={() => {
                                    this.addNew();
                                }}
                            >
                                +
                            </button>
                        </div>
                    )}
            </div>
        );
    }

    renderBody() {
        return (
            <div>
                {!this.state.showAdd && (
                    <div>
                        <header>
                            <div className="left">
                                Ruben: {this.state.rubenTotal}
                            </div>
                            <div className="right">
                                Tinne: {this.state.tinneTotal}
                            </div>
                        </header>
                        <section>
                            <div className="transactions">
                                {this.state.transactions.map(tx => (
                                    <div className="transaction" key={tx.key}>
                                        <div className="date">{tx.date}</div>
                                        <div className="desc">{tx.desc}</div>
                                        <div className="amounts">
                                            <span className="ruben">
                                                R {tx.ruben || "€ 0.00"}
                                            </span>
                                            <span className="tinne">
                                                T {tx.tinne || "€ 0.00"}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                )}
                {this.state.showAdd && (
                    <form onSubmit={this.handleSubmit}>
                        <header>
                            <div className="left">Add new</div>
                            <div className="right">
                                <button
                                    onClick={e =>
                                        this.setState({ showAdd: false })
                                    }
                                >
                                    Back
                                </button>
                            </div>
                        </header>
                        <div className="form-group">
                            <label htmlFor="date">Date</label>
                            <input
                                id="date"
                                name="date"
                                type="date"
                                value={this.state.new.date}
                                onChange={this.handleDate}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="desc">What?</label>
                            <input
                                id="desc"
                                name="desc"
                                type="text"
                                value={this.state.new.desc}
                                onChange={this.handleDesc}
                                required
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="ruben">Ruben</label>
                            <input
                                id="ruben"
                                name="ruben"
                                type="number"
                                value={this.state.new.ruben}
                                onChange={this.handleRuben}
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="tinne">Tinne</label>
                            <input
                                id="tinne"
                                name="tinne"
                                type="number"
                                value={this.state.new.tinne}
                                onChange={this.handleTinne}
                                step="0.01"
                            />
                        </div>
                        <div className="form-group">
                            <button type="submit">Add</button>
                        </div>
                    </form>
                )}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js